import { render, staticRenderFns } from "./FormCrudCompany.vue?vue&type=template&id=820fca60&scoped=true&"
import script from "./FormCrudCompany.vue?vue&type=script&lang=js&"
export * from "./FormCrudCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820fca60",
  null
  
)

export default component.exports